// extracted by mini-css-extract-plugin
export default {"wrapper":"bottomNavBar_wrapper__Zs4i1"};